/**
 * 현재 브라우저의 addEventListener passive option 적용 가능 여부
 * reference: https://gist.github.com/stevewithington/32ad085d23e43548c03b2615cf236540
 * */
export const isPassiveSupported = (eventTarget: HTMLElement | (Window & typeof globalThis) = window): boolean => {
  let supported = false;
  let options = {};

  try {
    options = {
      get passive() {
        supported = true;
        return null;
      },
    };

    const callback = (): null => {
      return null;
    };

    eventTarget.addEventListener('test', callback, options);
    eventTarget.removeEventListener('test', callback, options);
  } catch {
    supported = false;
  }

  return supported;
};
